import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import { TextBoxSize } from '@/components/view/atoms/textfield/TextField'

const gapClassMap = {
  0: 'gap-0',
  2: 'gap-0.5',
  4: 'gap-1',
  8: 'gap-2',
  12: 'gap-3',
  16: 'gap-4'
}

interface Props extends ChildProps {
  direction?: 'horizon' | 'vertical'
  flex1?: boolean
  size?: TextBoxSize | 320 | 400 | 248
  gap?: 0 | 2 | 4 | 8 | 12 | 16
  align?: 'start' | 'center' | 'baseline' | 'end'
  justify?: 'start' | 'between'
}

const FormRow = ({
  children,
  direction = 'horizon',
  size = TextBoxSize.FULL,
  flex1,
  gap = 16,
  align = 'start',
  justify = 'start'
}: Props) => {
  const widthClass =
    size == TextBoxSize.X_SMALL
      ? 'w-14 max-w-14'
      : size == TextBoxSize.SMALL
        ? 'w-22 max-w-22'
        : size == TextBoxSize.MEDIUM
          ? 'w-46 max-w-46'
          : size == TextBoxSize.LARGE
            ? 'w-full max-w-[28rem]'
            : size == TextBoxSize.FULL
              ? 'w-full max-w-full'
              : size == TextBoxSize.REMNANT
                ? 'flex-1'
                : size == TextBoxSize.FIT
                  ? 'w-fit'
                  : size == 320
                    ? 'w-[320px] max-w-[320px]'
                    : size == 400
                      ? 'w-[400px] max-w-[400px]'
                      : size == 248
                        ? 'w-[248px] max-w-[248px]'
                        : ''
  return (
    <>
      <div
        className={clsx(
          'flex',
          size && widthClass,
          flex1 && 'flex flex-1',
          direction == 'vertical'
            ? `flex-col items-${align} justify-start`
            : `items-${align} justify-${justify}`,
          gapClassMap[gap]
        )}
      >
        {children}
      </div>
    </>
  )
}

export default FormRow
